import Handler from "../Handler";

class FavouriteTablesHandler extends Handler {
  execute(message) {
    let parsedData = JSON.parse(message);
    this.service.processFavouriteTables(parsedData);
  }
}

export default FavouriteTablesHandler;
